const actions = {
  cardDesignApiName: 'CARD_DESIGN_API',
  requestCardDesign: 'cardDesign/request',
}

export default actions
